import { render } from "./modalInvOnLine.vue?vue&type=template&id=a47c6ef8"
import script from "./modalInvOnLine.vue?vue&type=script&lang=js"
export * from "./modalInvOnLine.vue?vue&type=script&lang=js"

import "./modalInvOnLine.vue?vue&type=style&index=0&id=a47c6ef8&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__